import React, { useEffect, useRef, useState } from "react";
import ReusableTable from "../../../components/common/table";
import DashboardCards from "./DashboardCards";
import LineChartComp from "./LineChartComp";
import BarChartComp from "./BarChartComp";
import { Avatar, Card, Col, Row } from "antd";
import PieChartComponent from "../../../components/PieChartComponent/PieChartComponent";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDashboardUsers,
  listTop100Listeners,
  listTopLeastListeners,
  listTopTenListeners,
} from "../../../redux/reducer/dashboardSlice";
import { useSearchParams } from "react-router-dom";
import DropdownSelect from "../../../components/common/select";
import { listTenantFun } from "../../../redux/reducer/TenantSlice";
import { UserOutlined } from "@ant-design/icons";
import { DownloadOutlined } from "@ant-design/icons";
import { Tooltip, Button } from "antd";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
const Dashboard = () => {
  const [tenantId, setTenantId] = useState(null);
  const pdfRef = useRef();
  const contentRef = useRef();

  // const downloadPDF = async () => {
  //   const element = document.getElementById("dashboardData");

  //   // Step 1: Wait for ALL images to load
  //   const images = element.querySelectorAll(".proImg");
  //   await Promise.all(
  //     Array.from(images).map((img) => {
  //       if (img.complete && img.naturalHeight !== 0) return Promise.resolve();
  //       return new Promise((resolve) => {
  //         img.onload = resolve;
  //         img.onerror = resolve;
  //       });
  //     })
  //   );

  //   // Step 2: Use html2canvas
  //   const canvas = await html2canvas(element, {
  //     scale: 2,
  //     useCORS: true, // Important if images are from CDN or other domains
  //     allowTaint: false,
  //   });

  //   // Step 3: Convert canvas to image and add to jsPDF
  //   const imgData = canvas.toDataURL("image/jpeg", 1.0);
  //   const pdf = new jsPDF({
  //     orientation: "portrait",
  //     unit: "px",
  //     format: [canvas.width, canvas.height],
  //   });

  //   pdf.addImage(imgData, "JPEG", 0, 0, canvas.width, canvas.height);
  //   pdf.save("Cultivate_Dashboard_Report.pdf");
  // };


  const downloadPDF = async () => {
    const element = document.getElementById("dashboardData");

    // Step 1: Wait for ALL images to load
    const images = element.querySelectorAll("img");
    await Promise.all(
      Array.from(images).map((img) => {
        if (img.complete && img.naturalHeight !== 0) return Promise.resolve();
        return new Promise((resolve) => {
          img.onload = resolve;
          img.onerror = resolve;
        });
      })
    );

    // Introduce a small delay to allow for rendering (adjust as needed)
    await new Promise((resolve) => setTimeout(resolve, 2000));

    // Step 2: Use html2canvas
    try {
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true, // Important for cross-origin images
        allowTaint: false,
      });

      // Step 3: Convert canvas to image and add to jsPDF
      const imgData = canvas.toDataURL("image/jpeg", 1.0);
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "px",
        format: [canvas.width, canvas.height],
      });

      pdf.addImage(imgData, "JPEG", 0, 0, canvas.width, canvas.height);
      pdf.save("Cultivate_Dashboard_Report.pdf");
    } catch (error) {
      console.error("Error during PDF generation:", error);
    }
  };

  const dispatch = useDispatch();
  const { dashboardUserData, dashboardUserLoading } = useSelector(
    (prev) => prev.dashboard
  );
  const {
    dashboardTopHundredLisnersData,
    dashboardTopLeastLisnersData,
    dashboardTopHundredLisnersCount,
    dashboardTopLeastLisnersCount,
    dashboardTopTenLisnersData,
    dashboardTopHundredLisnersLoading,
  } = useSelector((prev) => prev.dashboard);

  const { listTenant, listTenantLoading } = useSelector((prev) => prev?.tenant);

  const [searchParams, setSearchParams] = useSearchParams();
  // Convert URLSearchParams to usable object
  const getInitialParams = () => {
    const page = parseInt(searchParams.get("page")) || 1;
    const size = parseInt(searchParams.get("size")) || 10;
    // const search_key = searchParams.get("search_key") || "all";
    // const search_value = searchParams.get("search_value") || "";
    const status = searchParams.get("status");
    const position = searchParams.get("position");

    return {
      page,
      size,
      // search_key,
      // search_value,
      status: status !== null ? Number(status) : undefined,
      position: position !== null ? Number(position) : undefined,
    };
  };

  // const [tableParams, setTableParams] = useState(getInitialParams());

  const [tableParams, setTableParams] = useState({
    topHundred: getInitialParams(),
    topLeast: getInitialParams(),
  });

  useEffect(() => {
    const params = {
      page: tableParams.page,
      size: tableParams.size,
      // search_key: tableParams.search_key,
      // search_value: tableParams.search_value,
    };

    if (tableParams.status !== undefined) params.status = tableParams.status;
    if (tableParams.position !== undefined)
      params.position = tableParams.position;

    setSearchParams(params);
  }, [tableParams, setSearchParams]);

  const getPaginationConfig = (type, totalCount) => ({
    pageSizeOptions: ["10", "20", "50", "100"],
    showSizeChanger: true,
    showQuickJumper: true,
    total: totalCount || 1,
    current: tableParams[type].page,
    pageSize: tableParams[type].size,
    onChange: (page, pageSize) => {
      setTableParams((prev) => ({
        ...prev,
        [type]: { ...prev[type], page, size: pageSize },
      }));
    },
  });

  useEffect(() => {
    let payload = {};
    if (tenantId === null) {
      payload = {
        ...tableParams.topHundred,
      };
    } else {
      payload = {
        ...tableParams.topHundred,
        tenant_id: tenantId,
      };
    }
    dispatch(listTop100Listeners(payload));
  }, [dispatch, tableParams.topHundred, tenantId]);

  useEffect(() => {
    let payload = {};
    if (tenantId === null) {
      payload = {};
    } else {
      payload = {
        tenant_id: tenantId,
      };
    }

    dispatch(fetchDashboardUsers(payload));
  }, [
    dispatch,
    tableParams.page,
    tableParams.size,
    tableParams.status,
    tableParams.position,
    tenantId,
  ]);

  useEffect(() => {
    let payload = {};
    if (tenantId === null) {
      payload = {
        ...tableParams.topLeast,
      };
    } else {
      payload = {
        ...tableParams.topLeast,
        tenant_id: tenantId,
      };
    }
    dispatch(listTopLeastListeners(payload));
  }, [dispatch, tableParams.topLeast, tenantId]);

  useEffect(() => {
    let payload = {};
    if (tenantId === null) {
      payload = {};
    } else {
      payload = { tenant_id: tenantId };
    }
    dispatch(listTopTenListeners(payload));
  }, [dispatch, tenantId]);

  useEffect(() => {
    dispatch(listTenantFun());
  }, [dispatch]);

  const listTenantData = [
    { label: "All", value: null },
    ...listTenant.map(({ id, name_en }) => ({
      label: name_en,
      value: id,
    })),
  ];

  const columnsHundred = [
    {
      title: "Sr. No.",
      dataIndex: "sr_no",
      key: "sr_no",
      render: (text, record, index) =>
        (tableParams.topHundred.page - 1) * tableParams.topHundred.size +
        index +
        1,
      width: "100px",
    },
    {
      title: "Podcast Title",
      dataIndex: "title_en",
      key: "podcast_title",
      type: "search",
      render: (text) => (
        <Tooltip title={text}>
          <span style={{ 
            whiteSpace: "nowrap", 
            overflow: "hidden", 
            textOverflow: "ellipsis", 
            display: "inline-block", 
            maxWidth: 350 
          }}>
            {text}
          </span>
        </Tooltip>
      ),
    },
    {
      title: "Total Listners",
      dataIndex: "listener_count",
      key: "total_views",
      width: "150px",
    },
  ];

  const columnsLeastHundred = [
    {
      title: "Sr. No.",
      dataIndex: "sr_no",
      key: "sr_no",
      render: (text, record, index) =>
        (tableParams.topLeast.page - 1) * tableParams.topLeast.size + index + 1,
      width: "100px",
    },
    {
      title: "Podcast Title",
      dataIndex: "title_en",
      key: "podcast_title",
      type: "search",
      render: (text) => (
        <Tooltip title={text}>
          <span style={{ 
            whiteSpace: "nowrap", 
            overflow: "hidden", 
            textOverflow: "ellipsis", 
            display: "inline-block", 
            maxWidth: 350 
          }}>
            {text}
          </span>
        </Tooltip>
      ),
    },
    {
      title: "Total Listeners",
      dataIndex: "listener_count",
      key: "total_views",
      width: "150px",
    },
  ];

  const columnsTop10 = [
    {
      title: "Sr. No.",
      dataIndex: "sr_no",
      key: "sr_no",
      render: (text, record, index) => index + 1,
      width: "100px",
    },
    { title: "Name", dataIndex: "name_en", key: "name" },
    { title: "Email", dataIndex: "email", key: "email" },
    {
      title: "Podcast Play",
      dataIndex: "total_listened_count",
      key: "date_added",
      type: "date",
      width: "120px",
    },
    {
      title: "Podcast Completed",
      dataIndex: "complete_listened_count",
      key: "date_added",
      type: "date",
      width: "180px",
    },
    {
      title: "Image",
      dataIndex: "profile_pic",
      key: "banner_media",
      render: (profile_pic) => (
        <div>
          {profile_pic ? (
            <img
               src={`${process.env.REACT_APP_IMAGE_URL}/${profile_pic}`}
              //  src={`https://cdn.pixabay.com/photo/2022/04/21/19/47/lion-7148207_1280.jpg`}
              alt="Banner"
              style={{
                width: 50,
                height: 50,
                objectFit: "cover",
                borderRadius: "50%",
              }}
            />
          ) : (
            <Avatar size={50} icon={<UserOutlined />} />
          )}
           
        </div>
      ),
    },
  ];

  return (
    // <PDFViewer>
    <div ref={pdfRef} id="dashboardData">
      <div className="dashboardCard mb-1">
        <DashboardCards dashboardUserData={dashboardUserData} tenantId={tenantId} />
      </div>

      <Row gutter={16}>
        <Col xs={24} sm={17}></Col>
        <Col xs={24} sm={6}>
          <DropdownSelect
            //  mode="multiple"
            value={tenantId}
            onChange={(value) => setTenantId(value)}
            options={listTenantData}
            placeholder="All"
          />
        </Col>
        <Col xs={24} sm={1}>
          <div className="mb-1 d-flex  align-left-data">
            <Tooltip title="Download Dashboard Report">
              <PDFDownloadLink document={Dashboard}>
                <Button
                  className="download-icon-btn"
                  onClick={downloadPDF}
                  icon={<DownloadOutlined />}
                  type="primary"
                ></Button>
              </PDFDownloadLink>
            </Tooltip>
          </div>
        </Col>
      </Row>

      <div className="charts">
        <div className="tableHeading">Podcast Listeners </div>
        <Row gutter={16}>
          <Col xs={24} sm={16}>
            <Card>
              <LineChartComp tenantId={tenantId} />
            </Card>
          </Col>
          <Col xs={24} sm={8}>
            <Card>
              <PieChartComponent data={dashboardUserData} />
            </Card>
          </Col>
          <Col xs={24} sm={24}>
            <div className="tableHeading mt-2">
              Podcast Category-wise Listeners & Completion
            </div>
            <Card>
              <BarChartComp tenantId={tenantId} />
            </Card>
          </Col>
        </Row>
      </div>

      <div className="tableHeading">Top 10 Listeners</div>
      <ReusableTable
        columns={columnsTop10}
        dataSource={dashboardTopTenLisnersData}
        loading={dashboardUserLoading}
        paginationConfig={false}
        actionItems={[]}
        useFixedHeight={true}
      />
      <div style={{ height: "60px" }}></div>

      <div className="tableHeading">Top 100 Most Listened </div>
      <ReusableTable
        columns={columnsHundred}
        dataSource={
          Array.isArray(dashboardTopHundredLisnersData)
            ? dashboardTopHundredLisnersData
            : []
        }
        paginationConfig={getPaginationConfig(
          "topHundred",
          dashboardTopHundredLisnersCount
        )}
        loading={dashboardTopHundredLisnersLoading}
        actionItems={[]}
        useFixedHeight={true}
      />
      <div className="tableHeading mt-1">Top 100 Least Listened </div>
      <ReusableTable
        columns={columnsLeastHundred}
        dataSource={
          Array.isArray(dashboardTopLeastLisnersData)
            ? dashboardTopLeastLisnersData
            : []
        }
        paginationConfig={getPaginationConfig(  
          "topLeast",
          dashboardTopLeastLisnersCount
        )}
        loading={false}
        actionItems={[]}
        useFixedHeight={true}
      />
    </div>
    // </PDFViewer>
  );
};

export default Dashboard;
